'use es6';

import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  screen: null,
  subscreen: null
});